<script setup lang="ts">
withDefaults(defineProps<{ compact?: boolean; inverse?: boolean }>(), {
  compact: false,
  inverse: false,
})
</script>

<template>
  <div class="brand" :class="{ 'brand--inverse': inverse }" aria-label="SkipHR">
    <svg class="brand__mark" viewBox="0 0 36 36" aria-hidden="true">
      <path d="M7.5 10.5 18 4l10.5 6.5v15L18 32 7.5 25.5v-15Z" fill="currentColor" />
      <path
        d="m12.4 13.2 5.7-3.5 5.5 3.5-5.7 3.5-5.5-3.5Zm0 4.9 5.5 3.5 5.7-3.5v4.8l-5.7 3.5-5.5-3.5v-4.8Z"
        fill="var(--brand-cut, #fff)"
      />
    </svg>
    <span v-if="!compact" class="brand__word">skip<span>hr</span></span>
  </div>
</template>
